<template>
    <span>
        <button id="voice-rec" class="small" @click="toggle()" title="Reconhecimento de voz">
            <i class="fa-solid fa-microphone-slash" v-if="!reconhecendo"></i>
            <i class="fa-solid fa-microphone text-danger" v-else></i>
        </button>

        <div class="snackbar az-anime-surgir card carde" v-if="reconhecendo">
            <div class="card-body py-1 px-2">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="recording-circle"></div>
                    <div class="recording-text ml-3">Fale ao microfone</div>
                    <a href="#" @click.prevent="fechar()">
                        <i class="fa fa-times ml-2 text-white" aria-hidden="true"></i>
                    </a>
                </div>
                <div class="text-white">
                    {{ runtimeTranscription ? runtimeTranscription : '' }}
                </div>
            </div>
        </div>
    </span>
    <!-- Reconhecimento de Voz -->
    <!--
    <div class="modal fade" id="vozRecModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content" v-if="reconhecendo">
                <div class="modal-header">
                    <h5 class="modal-title">Reconhecimento de Voz</h5>
                        <button type="button" class="close" aria-label="Close" @click="fechar()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                </div>
                <div class="modal-body">

                    <div class="alert alert-danger" v-if="error">{{ error }}</div>

                    <template v-else> 

                        <small>Fale ao microfone:</small>

                        <div class="alert alert-info" id="textorec">
                            <span v-if="transcription && transcription.length" class="mr-3" style="white-space: pre;">{{ tratar_pontuacao(transcription.join(' ')) }}</span>
                            <span class="text-muted">{{ runtimeTranscription }}</span>
                        </div>

                    </template>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                    <button type="button" class="btn btn-success" @click="copiar()">Copiar</button>
                </div>
            </div>
        </div>
    </div>
    -->
</template>

<script>
import _ from 'lodash';

export default {
    data() { 
        return { 
            reconhecendo: false,
            error: "", 
            runtimeTranscription: '',
            runtimePos: 0,
            runtimeLen: 0, 
            transcription: [],
            lang: 'pt-Br',
            recognition: null, 
            range: null,
            sel: null, 
            node: null, 
        }
    },

    methods: { 
        copiar_clipboard (text) { 
            if (!navigator.clipboard) {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position="fixed";  //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Fallback: Copying text command was ' + msg);
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }

                document.body.removeChild(textArea);
            } else { 
                navigator.clipboard.writeText(text).then(function() {
                    console.log('Async: Copying to clipboard was successful!');
                }, function(err) {
                    console.error('Async: Could not copy text: ', err);
                });
            }

            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "Texto copiado para a área de transferência.",
                life: 3000
            });
        },

        toggle() { 
            if ( this.reconhecendo ) { 
                this.fechar();
            } else { 
                this.abrir();
            }
        },

        fechar(saindo = false) { 
            //$('#vozRecModal').modal('hide');
            this.reconhecendo = false;

            if ( this.recognition )
                this.recognition.abort();

            if ( !saindo ) { 
                this.$parent.quill.focus();
            }

            /*
            this.$toast.add({
                severity: "success",
                summary: "Reconhecimento de Voz",
                detail: 'Encerrado!',
                life: 3000
            });     
            */
        },

        copiar() { 
            const texto = this.transcription.join(' ') + this.runtimeTranscription;
            this.copiar_clipboard(this.tratar_pontuacao(texto.trim()));
            this.fechar();
        },

        abrir() { 
            this.runtimePos = 0;
            this.runtimeLen = 0;
            this.range = null;
            this.runtimeTranscription = '';
            this.transcription = [];

            this.reconhecendo = true;
            //$('#vozRecModal').modal('show');

            this.$nextTick(() => { 
                this.checkApi();
            });
            
            this.$parent.quill.focus();
        },

        tratar_pontuacao(texto) { 
            if ( !texto )
                return texto;

            const dic = [
                { from: ' vírgula', to: ',', },
                { from: ' ponto parágrafo', to: '.\n', },
                { from: ' ponto', to: '.', },
                { from: ' próxima linha', to: '\n', },
            ];

            dic.forEach(item => {
                if ( texto.indexOf(item.from) >= 0 ) { 
                    texto = texto.replace(item.from, item.to);
                }
            });

            dic.forEach(item => {
                if ( texto === item.from.trim() ) { 
                    texto = texto.replace(item.from.trim(), item.to);

                    if ( this.$parent.quill.getText(this.runtimePos - 1, 1) == ' ' ) { 
                        this.runtimePos--;
                        this.runtimeLen++;
                    }
                }
            });

            return texto;
        },

        checkApi () {
            window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
            if (!window.SpeechRecognition) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Reconhecimento de Voz não disponível nesse browser. Use Chrome ou Firefox.',
                    life: 5000
                });     
                return;
            }

            //this.recognition = new SpeechRecognition()
            this.recognition = new window.webkitSpeechRecognition;
            this.recognition.lang = this.lang
            this.recognition.interimResults = true
            this.recognition.addEventListener('result', event => {
                if ( this.runtimePos || this.runtimeLen ) { 
                    this.$parent.quill.deleteText(this.runtimePos, this.runtimeLen);
                }

                let selection = this.$parent.quill.getSelection(true);

                this.runtimePos = selection ? selection.index : 0;

                const text = Array.from(event.results)
                    .map(result => result[0])
                    .map(result => result.transcript)
                    .join('');

                /*
                if ( text == 'stop' ) { 
                    this.fechar();
                    return;
                }
                */

                this.runtimeTranscription = text;

                this.runtimeLen = text.length;

                this.$parent.quill.insertText(this.runtimePos, text);
            })
            this.recognition.addEventListener('end', () => {
                if (this.runtimeTranscription !== '') {
                    this.transcription.push(this.runtimeTranscription)
                    this.$emit('onTranscriptionEnd', {
                        transcription: this.transcription,
                        lastSentence: this.runtimeTranscription
                    });

                    let text = this.tratar_pontuacao(this.transcription.join(' '));

                    let pos = this.runtimePos;
                    let len = this.runtimeLen;

                    this.runtimePos = 0; 
                    this.runtimeLen = 0;
                    
                    if ( pos || len ) { 
                        this.$parent.quill.deleteText(pos, len);
                    }

                    if ( text ) { 
                        // Tratamento de caracters maiusculas.

                        let maiuscula = false;

                        if ( !pos && len ) { 

                            maiuscula = true;

                        } else { 
                            let antes = this.$parent.quill.getText(pos - 1, 1);

                            if ( antes == '\n' ) { 
                                maiuscula = true;
                            }

                            if ( pos > 2 ) { 

                                antes = this.$parent.quill.getText(pos - 2, 2);

                                if ( antes == '. ' ) { 
                                    maiuscula = true;
                                }

                            }
                        }

                        if ( maiuscula ) { 
                            text = text.substring(0, 1).toUpperCase() + text.substring(1);
                        }

                        //

                        if ( text.trim() == 'stop' ) { 
                            this.fechar();
                            return;
                        } else if ( text.substring(text.length - 5, text.length) == ' stop' ) { 
                            text = text.substring(0, text.length - 5);
                            this.fechar();
                        } else { 
                            if ( this.$parent.textos && this.$parent.textos.length ) { 
                                let token = _.last(text.split(' '));

                                let frase = this.$parent.textos.find(item => item && item.st_atalho && item.st_atalho.toUpperCase() == token.toUpperCase());

                                if ( frase ) { 
                                    text = text.slice(0, text.length - token.length) + frase.st_texto;
                                    text = text.replace('</p>', '\n');
                                    text = text.replace('<br>', '\n');
                                    text = text.replace('<br />', '\n');
                                    text = text.replace(/<\/?[^>]+(>|$)/g, "");
                                }
                            }

                            if ( text && text.substring(text.length - 1, text.length) != '\n' ) { 
                                text = text + ' ';
                            }
                        }

                        if ( text ) { 
                            this.$parent.quill.insertText(pos, text);
                        }
                    }
                
                    // Inclusão do texto na posição do cursor...

                    this.transcription = [];
                }
                this.runtimeTranscription = ''
                
                if ( this.reconhecendo )
                    this.recognition.start();
            })
            this.recognition.start();

            /*
            this.$toast.add({
                severity: "success",
                summary: "Reconhecimento de Voz",
                detail: 'Iniciado!',
                life: 3000
            });     
            */
        }
    },

    beforeDestroy() { 
        if ( this.reconhecendo ) { 
            this.fechar(true);
        }
    }
}
</script>

<style scoped>
.snackbar {
  min-width: 250px; /* Set a default minimum width */
  margin-left: -125px; /* Divide value of min-width by 2 */
  background-color: #000; /* Black background color */
  color: rgb(99, 99, 99);; /* White text color */
  text-align: center; /* Centered text */
  border-radius: 2px; /* Rounded borders */
  position: fixed; /* Sit on top of the screen */
  z-index: 99999; /* Add a z-index if needed */
  left: 50%; /* Center the snackbar */
  top: 14px; /* 30px from the bottom */
}

.recording-circle {
  background-color: red;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  animation: ease pulse 2s infinite;
  margin-right: 0.25em;
}

.recording-text {
  color: white;
}

@keyframes pulse {
  0% {
    background-color: red;
  }
  50% {
    background-color: #fa8072;
  }
  100% {
    background-color: red;
  }
}
</style>